export interface ChangeProcessPlaceRequest {
  branchCode: string
  placeCode: string
  _force: boolean
}

export function ChangeProcessPlaceRequestToJSON(
  value: ChangeProcessPlaceRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    place_code: value.placeCode !== '' ? value.placeCode : undefined,
    _force: value._force ?? undefined
  }
}
